export default __webpack_public_path__ + "static/media/mayorista.f396b18e.svg";